var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            rules: _vm.rules,
            model: _vm.childData,
            "label-position": "right",
            "label-width": "100px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.roleName"), prop: "roleName" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                model: {
                  value: _vm.childData.roleName,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "roleName", $$v)
                  },
                  expression: "childData.roleName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("table.roleRemark"), prop: "roleRemark" }
            },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 6, maxRows: 6 }
                },
                model: {
                  value: _vm.childData.roleRemark,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "roleRemark", $$v)
                  },
                  expression: "childData.roleRemark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }